import React from 'react';

import {ROLES} from './Menu';
import Option, {OptionProps} from './Option';
/**
 * Renders a footer option in a Menu.
 */
export default function FooterOption<T>(props: OptionProps<T>): JSX.Element | null {
  // See Menu implementation -- the children are rendered as is, followed by a divider.
  return <Option {...props} />;
}

FooterOption.defaultProps = {
  _role: ROLES.FOOTER_OPTION,
  shouldEllipsize: false,
};
